import { render } from "./PageCard.vue?vue&type=template&id=5a967a6b&scoped=true"
import script from "./PageCard.vue?vue&type=script&lang=js"
export * from "./PageCard.vue?vue&type=script&lang=js"

import "./PageCard.vue?vue&type=style&index=0&id=5a967a6b&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a967a6b"]])

export default __exports__